// extracted by mini-css-extract-plugin
export var checkbox = "_9c-0";
export var circle = "_9c-3";
export var horizontalContainer = "_9c-7";
export var sm = "_9c-5";
export var switch0 = "_9c-2";
export var switchDisabled = "_9c-8";
export var switchEnabled = "_9c-1";
export var textSwitchContainer = "_9c-9";
export var textSwitchOption = "_9c-a";
export var textSwitchOptionSelected = "_9c-b";
export var verticalContainer = "_9c-6";
export var xs = "_9c-4";